import styled from 'styled-components';
import { MediaQueryBreakpoints } from '@rockalingua/ui';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  padding: 48px;

  @media only screen and (max-width: ${MediaQueryBreakpoints.sm}px) {
    padding: 24px;
  }
`;
